<!-- <div class="row">
<div class="d-flex days-selector-wrapper ml-3 mr-3">
  <div class="flex-fill">
    <div class="d-flex justify-content-center week-days">
      Go to date
    </div>
    <div class="d-flex justify-content-center week-date">
      <div class="input-group mb-3 input-group-sm">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <label for="dateToInput" class="btn btn-default"><i class="fa fa-calendar"></i></label>
          </span>
        </div>
        <input type="text" style="display: none" id="dateToInput" ngxDaterangepickerMd
          class="form-control choose-date" placeholder="Choose date" showCancel="true" [singleDatePicker]="true"
          [locale]="locale" [minDateNumber]="1" [minDate]="minDate" [opens]="'center'" [showDropdowns]="true"
          [value]="value" (datesUpdated)="onChange($event)" />
      </div>
    </div>
  </div>
  <div class="flex-fill" *ngFor="let date of dates">
    <div class="d-flex justify-content-center week-days">
      {{date.dayOfWeek}}
    </div>
    <div class="d-flex justify-content-center week-date">
      <div class="d-flex align-items-end appt-day-wrapper"
        [ngClass]="(clickedDate == date || clickedDate.shortDate == date.shortDate ? 'active':'')"
        (click)="choose(date);">
        <div class="appt-days">{{date.day}}</div>
        <div class="">{{date.month}}</div>
      </div>
    </div>
  </div>
</div>
</div> -->
<div class="_wf-pp-rightdivcalender">
  <div class="_wf-pp-daydate">
    <div class="_wf-pp-text-block-41">{{'field.label.slected_date' | translate | async}}<br><span
    class="_wf-pp-text-span-5">{{hasSelectedDate.date | dateFormat}}</span></div>
  </div>
  <div class="_wf-calendar-right-section">
    @if (checkShowCalendarPermission() && showCalender) {
    <div class="check-slot-button" (click)="showCalenderDetails()">
        <div class="">{{"machine_calender_slot"|translate|async}}</div>
        <i class="fa fa-calendar" aria-hidden="true"></i>
      </div>
    }
    @if (fifteenDaySlot && checkAccessPermission) {
      <div class="check-slot-button" (click)="hasFifteenDays()">
        @if (nextAvailableSlotConfigValue > 0) {
          <div class="">{{("avndays"|translate|async)?.replace('{days}', '' + nextAvailableSlotConfigValue)}}</div>
        } @else {
          <div class="">{{"av15days"|translate|async}}</div>
        }
        <i class="fa fa-history" aria-hidden="true"></i>
      </div>
    }
    
    @if (checkPermission() && showHideDetails) {
      <div class="show-hide-tooltip">
        <div class="custom-control custom-switch mr-3 p-0 table-switch">
          <input class="custom-control-input" id="customSwitch" type="checkbox" [checked]="getPatientDetails()" (change)="hideDetials($event)">
          <label class="custom-control-label" for="customSwitch">
          </label>
          <p>{{"hide_details" |translate|async}}</p>
        </div>
      </div>
    }
    <div class="_wf-pp-jumptocalender w-clearfix" style="width: 114px;">
      <div class="input-group" (click)="moreDate();">
        <div class="">
          <span class="">
            <label for="dateToInput{{id}}">{{'field.label.slected_date' | translate | async}} <i
            class="fa fa-calendar"></i></label>
          </span>
        </div>
        <input type="text" style="display: none" id="dateToInput{{id}}" ngxDaterangepickerMd
          class="form-control choose-date datepicker-search" placeholder="Choose date" showCancel="true"
          [singleDatePicker]="true" [locale]="locale" [minDateNumber]="1" [minDate]="minDate" [maxDate]="hasMaxDate"
          [showClearButton]="false" [opens]="'center'" [showDropdowns]="true" [value]="value"
          (datesUpdated)="onChange($event)" />
      </div>
    </div>
  </div>
</div>

<div class="_wf-pp-calendertable">
  @for (date of dates; track date; let i = $index; let isFirst = $first) {
    <div class="_wf-pp-calenderday" [ngClass]="date.disable?'disable-calendar':''">
      <div class="wx-pp-calendertext">{{date.dayOfWeek | translate | async}}</div>
      <div class="_wf-pp-daysdiv _wf-pp-todaydiv" (click)="choose(date);">
        <div class="_wf-pp-calenderdate"
          [ngClass]="(clickedDate == date || clickedDate.shortDate == date.shortDate ? 'active':'')">
          @if (isFirst && today) {
            <div class="_wf-pp-text-block-36 _wf-pp-calendrtoday">{{'field.label.Today' |
            translate | async}}</div>
          }
          @if (!isFirst && today) {
            <div class="_wf-pp-text-block-36"><span
              class="_wf-pp-text-span-6">{{date.day}}</span><br>{{date.month}}</div>
            }
            @if (!today) {
              <div class="_wf-pp-text-block-36"><span
                class="_wf-pp-text-span-6">{{date.day}}</span><br>{{date.month}}</div>
              }
            </div>
          </div>
        </div>
      }
    </div>